import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Maximize2 } from 'lucide-react';

const CollapsibleSection = ({
  title,
  subtitle,
  children,
  defaultCollapsed = false,
  className = '',
  sectionId,
  onUndock
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  return (
    <div className={`editor-section ${className}`}>
      <div
        className="section-header"
        onClick={() => setIsCollapsed(!isCollapsed)}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          userSelect: 'none',
          flexWrap: 'wrap'
        }}
      >
        {isCollapsed ? (
          <ChevronRight size={14} />
        ) : (
          <ChevronDown size={14} />
        )}
        <div style={{ flex: 1 }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          {subtitle && <span className="section-subtitle">{subtitle}</span>}
        </div>
        {sectionId && onUndock && (
          <button
            className="section-undock-btn"
            onClick={(e) => { e.stopPropagation(); onUndock(sectionId); }}
            title="Tear off as floating panel"
            style={{
              background: 'none',
              border: '1px solid var(--color-border-light)',
              borderRadius: 'var(--radius-sm)',
              cursor: 'pointer',
              padding: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              color: 'var(--color-text-tertiary)',
            }}
          >
            <Maximize2 size={12} />
          </button>
        )}
      </div>

      {!isCollapsed && (
        <div className="section-content" style={{ marginTop: '8px' }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;